exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".van-pull-refresh{-webkit-user-select:none;user-select:none;overflow:hidden}.van-pull-refresh__track{position:relative}.van-pull-refresh__head{width:100%;height:50px;left:0;overflow:hidden;position:absolute;text-align:center;top:-50px;font-size:14px;color:#969799;line-height:50px}.van-pull-refresh__loading .van-loading{width:16px;height:16px;margin-right:5px}.van-pull-refresh__loading .van-loading,.van-pull-refresh__loading span{vertical-align:middle;display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vant/es/pull-refresh/index.css
// module id = 252
// module chunks = 0